import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { STRINGS } from "@/i18n/strings";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("mq_lang") || "en");

  useEffect(() => {
    localStorage.setItem("mq_lang", lang);
  }, [lang]);

  const t = useCallback(
    (key, vars) => {
      let s = (STRINGS[lang] && STRINGS[lang][key]) || STRINGS.en[key] || key;
      if (vars && typeof s === "string") {
        for (const [k, v] of Object.entries(vars)) {
          s = s.split(`{${k}}`).join(String(v));
        }
      }
      return s;
    },
    [lang]
  );

  // Memoise the context value so children only re-render when {lang,t} change.
  const value = useMemo(() => ({ lang, setLang, t }), [lang, t]);

  return (
    <I18nContext.Provider value={value}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be inside I18nProvider");
  return ctx;
}
